import React from "react";
import { useNavigate } from "react-router-dom";
import "./privacyPolicy.scss";

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="privacy-policy">
      <div className="privacy-policy__panel card border-0">
        <div className="card-body p-md-5 privacy-policy__panel__container">
          <button
            type="button"
            className="btn btn-outline-light btn-sm mb-4"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left me-2" />
            Wróć
          </button>

          <div className="privacy-policy__eyebrow">
            <span className="privacy-policy__eyebrow-icon" aria-hidden="true">
              <i className="bi bi-shield-lock-fill" />
            </span>
            <span>Ochrona danych i prywatność użytkownika</span>
          </div>

          <h1 className="privacy-policy__title mb-1">Polityka prywatności</h1>
          <p className="privacy-policy__subtitle mb-4">
            Serwis: <strong>hearingtest.swiat-sluchu.pl</strong> &mdash; ostatnia aktualizacja: kwiecień 2025
          </p>

          <div className="privacy-policy__summary" role="note" aria-label="Najważniejsze informacje">
            <div className="privacy-policy__summary-item">
              <i className="bi bi-person-vcard" aria-hidden="true" />
              <span>Tworząc konto, zapisujesz historię wyników i ustawienia aplikacji.</span>
            </div>
            <div className="privacy-policy__summary-item">
              <i className="bi bi-database-check" aria-hidden="true" />
              <span>Przechowujemy wyłącznie dane niezbędne do działania konta i testów.</span>
            </div>
            <div className="privacy-policy__summary-item">
              <i className="bi bi-envelope-paper" aria-hidden="true" />
              <span>W każdej chwili możesz poprosić o dostęp, poprawienie lub usunięcie swoich danych.</span>
            </div>
          </div>

          <hr className="privacy-policy__divider" />

          <section className="privacy-policy__section">
            <h2><i className="bi bi-building" aria-hidden="true" /> 1. Administrator danych</h2>
            <p>
              Administratorem danych osobowych zbieranych za pośrednictwem serwisu
              <strong> hearingtest.swiat-sluchu.pl</strong> jest firma{" "}
              <strong>Świat Słuchu</strong> z siedzibą w Polsce. W sprawach
              dotyczących ochrony danych osobowych można kontaktować się pod adresem
              e-mail: <a href="mailto:adam.borkowski@swiat-sluchu.pl">adam.borkowski@swiat-sluchu.pl</a>.
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-journal-text" aria-hidden="true" /> 2. Cel i podstawa przetwarzania danych</h2>
            <p>Dane osobowe są przetwarzane w następujących celach:</p>
            <ul>
              <li>
                <strong>Rejestracja i obsługa konta użytkownika</strong> – na podstawie
                art. 6 ust. 1 lit. b RODO (niezbędność do wykonania umowy).
              </li>
              <li>
                <strong>Przechowywanie historii wyników badania słuchu</strong> – na
                podstawie zgody użytkownika (art. 6 ust. 1 lit. a RODO).
              </li>
              <li>
                <strong>Logowanie przez Google OAuth</strong> – na podstawie zgody
                użytkownika wyrażonej podczas autoryzacji.
              </li>
              <li>
                <strong>Bezpieczeństwo i zapobieganie nadużyciom</strong> – uzasadniony
                interes administratora (art. 6 ust. 1 lit. f RODO).
              </li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-collection" aria-hidden="true" /> 3. Zakres zbieranych danych</h2>
            <p>W zależności od sposobu korzystania z serwisu możemy zbierać:</p>
            <ul>
              <li>Adres e-mail i nazwa użytkownika (przy rejestracji).</li>
              <li>Wyniki przeprowadzonych testów słuchu (audiogramy).</li>
              <li>Adres IP oraz ciąg identyfikacyjny przeglądarki (<em>User-Agent</em>).</li>
              <li>Dane profilu Google (imię, adres e-mail, identyfikator) – wyłącznie
                przy logowaniu przez Google OAuth.</li>
              <li>Ustawienia personalizacji aplikacji (motyw, parametry testu).</li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-clock-history" aria-hidden="true" /> 4. Okres przechowywania danych</h2>
            <p>
              Dane konta i wyniki badań przechowywane są do momentu usunięcia konta
              przez użytkownika lub na pisemny wniosek skierowany do administratora.
              Dane techniczne (logi serwera) przechowywane są przez maksymalnie 90 dni.
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-person-check" aria-hidden="true" /> 5. Prawa użytkownika</h2>
            <p>Użytkownikowi przysługują następujące prawa:</p>
            <ul>
              <li>Prawo dostępu do swoich danych (art. 15 RODO).</li>
              <li>Prawo do sprostowania danych (art. 16 RODO).</li>
              <li>Prawo do usunięcia danych („prawo do bycia zapomnianym", art. 17 RODO).</li>
              <li>Prawo do ograniczenia przetwarzania (art. 18 RODO).</li>
              <li>Prawo do przenoszenia danych (art. 20 RODO).</li>
              <li>Prawo do wniesienia sprzeciwu wobec przetwarzania (art. 21 RODO).</li>
              <li>
                Prawo do wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych
                (UODO), jeżeli użytkownik uważa, że przetwarzanie narusza przepisy RODO.
              </li>
            </ul>
            <p>
              W celu skorzystania z powyższych praw należy skontaktować się pod adresem:{" "}
              <a href="mailto:adam.borkowski@swiat-sluchu.pl">adam.borkowski@swiat-sluchu.pl</a>.
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-hdd-network" aria-hidden="true" /> 6. Pliki cookie i pamięć lokalna</h2>
            <p>
              Serwis korzysta z mechanizmu <em>localStorage</em> i{" "}
              <em>sessionStorage</em> przeglądarki wyłącznie w celu przechowywania
              tokena sesji, preferencji użytkownika oraz jednorazowych komunikatów
              informacyjnych. Serwis nie korzysta z plików cookie stron trzecich
              służących do śledzenia aktywności w celach reklamowych.
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-box-arrow-up-right" aria-hidden="true" /> 7. Usługi zewnętrzne</h2>
            <ul>
              <li>
                <strong>Google OAuth 2.0</strong> – logowanie za pomocą konta Google.
                Korzystanie z tej funkcji podlega{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Polityce prywatności Google
                </a>
                .
              </li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-shield-check" aria-hidden="true" /> 8. Bezpieczeństwo danych</h2>
            <p>
              Komunikacja między przeglądarką a serwerem jest szyfrowana przy użyciu
              protokołu HTTPS/TLS. Hasła użytkowników są przechowywane wyłącznie w
              postaci zaszyfrowanej (bcrypt). Administrator stosuje odpowiednie środki
              techniczne i organizacyjne w celu ochrony danych przed nieuprawnionym
              dostępem.
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2><i className="bi bi-arrow-repeat" aria-hidden="true" /> 9. Zmiany polityki prywatności</h2>
            <p>
              Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej
              polityce prywatności. O wszelkich istotnych zmianach użytkownicy
              zalogowani zostaną poinformowani za pośrednictwem serwisu. Korzystanie
              z serwisu po wprowadzeniu zmian oznacza ich akceptację.
            </p>
          </section>

          <hr className="privacy-policy__divider" />
          <p className="privacy-policy__footer-note">
            Dokument obowiązuje od <strong>1 kwietnia 2025</strong> r.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
